<template>
    <div class="timetable-wrapper timetable-text-wrapper">
        <timetable-view-text :date="date"
                             :events="events"
                             :texts="texts"
        ></timetable-view-text>
    </div>
</template>

<script>
    import 'moment-recur';

    import {EventAPI} from './mixins/EventAPI';
    import {EventBus} from './mixins/EventBus';
    import TimetableViewText from './TimetableView-Text.vue';

    export default {
        mixins: [EventAPI, EventBus],
        components: {
            'timetable-view-text': TimetableViewText,
        },
        props: {
            showDate: {
                default: () => new Date()
            },
            showFirstEvent: {
                default: false
            },
            showFirstWeek: {
                default: true
            },
            showEvents: {
                default: () => []
            },
            eventsUrl: {
                default: null
            },
            translations: {
                default: () => {}
            },
        },

        data() {
            return {
                date: moment(this.showDate),
                events: this.showEvents,
                eventTemplates: this.showEventTemplates,
                texts: {
                    ...this.translations
                },
            }
        },

        created() {
            this.getEvents().then(() => {
                this.fixInitialDate();
            });
        },

        mounted() {
            // console.log('Timetable Text Component Mounted.');
        },

        methods: {
            fixInitialDate() {
                if ((this.showFirstEvent && this.date.isSame(moment(), 'day') || this.showFirstWeek) && this.events.length) {
                    let first_date = moment(this.events[0]._start_time);
                    let last_date = moment(this.events[0]._start_time);
                    this.events.forEach((event) => {
                        if (event._start_time < first_date) {
                            first_date = event._start_time;
                        }
                        if (event._start_time > last_date) {
                            last_date = event._start_time;
                        }
                    });

                    if (first_date > this.date || last_date < this.date || this.showFirstWeek) {
                        this.date = first_date;
                        this.eventBus.$emit('date-changed', this.date);
                    }
                }
            },
        }
    }
</script>
<style lang="scss">
    .timetable-text-wrapper {
        display: inline;

        div {
            display: inline;
        }
    }
</style>
